import React from 'react';
import { Loader } from 'semantic-ui-react'

export default () => (
  <div style={{ height: 100, position: 'relative'}}>
    <Loader active />
  </div>
);
